function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Platform } from 'react-native';
import { createConfig, signIn, getAccessToken } from '@okta/okta-react-native';
import { OktaAuth } from '@okta/okta-auth-js';
export class Okta {
  constructor(AUTH_CLIENT_ID, AUTH_REDIRECT_URI, AUTH_END_SESSION_REDIRECT_URI, AUTH_DISCOVERY_URI) {
    _defineProperty(this, "authClient", void 0);

    if (Platform.OS === 'web') {
      this.authClient = new OktaAuth({
        issuer: AUTH_DISCOVERY_URI,
        clientId: AUTH_CLIENT_ID,
        redirectUri: AUTH_REDIRECT_URI
      });
    } else {
      createConfig({
        clientId: AUTH_CLIENT_ID,
        redirectUri: AUTH_REDIRECT_URI,
        endSessionRedirectUri: AUTH_END_SESSION_REDIRECT_URI,
        discoveryUri: AUTH_DISCOVERY_URI,
        scopes: ['openid', 'profile', 'offline_access', 'groups'],
        requireHardwareBackedKeyStore: false
      });
    }
  }

  async signIn(credentials) {
    try {
      if (Platform.OS === 'web') {
        const result = await this.authClient.signInWithCredentials(credentials);
        await this.authClient.token.getWithRedirect({
          sessionToken: result.sessionToken,
          responseType: 'id_token'
        });
        return result;
      } else {
        return await signIn(credentials);
      }
    } catch (e) {
      return {
        failed: true
      };
    }
  }

  async token() {
    if (Platform.OS === 'web') {
      return this.authClient.getAccessToken();
    } else {
      return (await getAccessToken()).access_token;
    }
  }

  isLoginRedirect() {
    return this.authClient.isLoginRedirect();
  }

  async parseToken() {
    return this.authClient.token.parseFromUrl().then(response => {
      return this.authClient.tokenManager.setTokens(response.tokens);
    });
  }

}
//# sourceMappingURL=index.js.map